import React from "react";
import LegalPage from "./LegalPage";

const sections = [
  {
    heading: "1. Informations que nous collectons",
    paragraphs: [
      "GoalFit est une application de fitness qui permet de creer un compte, definir des objectifs hebdomadaires, suivre des seances, trouver un coach et gerer certaines options de compte depuis l'application mobile.",
      "Selon votre utilisation, nous pouvons collecter les informations que vous fournissez directement ainsi que certaines donnees techniques necessaires au fonctionnement du service."
    ],
    bullets: [
      "Informations de compte : nom complet, numero de telephone, mot de passe, role utilisateur (trainee ou coach).",
      "Informations de verification et de connexion : donnees liees a l'OTP, identifiants de session et jetons d'authentification.",
      "Informations d'utilisation : objectifs choisis, frequence d'entrainement, jours selectionnes, niveau d'intensite, progression, seances terminees et statistiques affichees dans le profil.",
      "Interactions sociales : messages echanges avec des coachs, preferences de notifications et reponses a certaines alertes.",
      "Informations techniques : identifiant OneSignal ou identifiants similaires pour les notifications push, type d'appareil et donnees de diagnostic de base.",
      "Informations de paiement et d'acces premium : etat d'abonnement, identifiants d'offre ou de produit et informations de restauration d'achat via RevenueCat et la boutique de votre plateforme. GoalFit ne stocke pas les numeros complets de carte bancaire dans ce site web.",
      "Informations optionnelles de portefeuille : si vous connectez LVC Pay, certaines informations de portefeuille ou d'etat de connexion peuvent etre traitees."
    ],
  },
  {
    heading: "2. Comment nous utilisons vos donnees",
    paragraphs: [
      "Nous utilisons ces informations pour fournir, securiser et ameliorer GoalFit."
    ],
    bullets: [
      "Creer et gerer votre compte.",
      "Verifier votre numero de telephone et vous connecter.",
      "Generer vos objectifs hebdomadaires et vos plans d'activites.",
      "Afficher vos statistiques, votre abonnement et votre progression.",
      "Permettre les echanges avec des coachs dans l'application.",
      "Envoyer des notifications push comme les rappels d'entrainement, mises a jour de progression, messages de coach et communications promotionnelles si elles sont activees.",
      "Traiter les achats integres, restaurer les achats et controler l'acces aux fonctionnalites payantes.",
      "Repondre aux demandes de support et aux demandes de suppression de compte."
    ],
  },
  {
    heading: "3. Base de partage et prestataires",
    paragraphs: [
      "Nous pouvons partager certaines donnees uniquement lorsque cela est necessaire au fonctionnement du service ou au respect d'obligations legales."
    ],
    bullets: [
      "Prestataires techniques et d'infrastructure relies a l'API GoalFit.",
      "OneSignal pour la gestion des notifications push.",
      "RevenueCat et les boutiques applicatives Apple App Store ou Google Play pour les abonnements et achats integres.",
      "Prestataires lies a LVC Pay si vous choisissez d'utiliser cette fonctionnalite.",
      "Autorites, conseillers ou partenaires lorsque la loi l'exige ou pour proteger nos droits."
    ],
  },
  {
    heading: "4. Conservation des donnees",
    paragraphs: [
      "Nous conservons les donnees aussi longtemps que necessaire pour exploiter GoalFit, respecter nos obligations legales, resoudre des litiges et faire appliquer nos accords. Certaines donnees peuvent rester dans des sauvegardes techniques pendant une periode limitee."
    ],
  },
  {
    heading: "5. Vos choix et vos droits",
    paragraphs: [
      "Vous pouvez gerer certaines informations directement dans l'application, notamment les preferences de notifications, certaines donnees de profil et les parametres du compte.",
      "Vous pouvez demander la suppression de votre compte et de vos donnees associees en nous contactant a goalfit.support@loven-soft.com. Si une option de suppression est disponible dans l'application, vous pouvez egalement l'utiliser."
    ],
    bullets: [
      "Desactiver les notifications push dans l'application ou dans les reglages de votre appareil.",
      "Demander l'acces, la correction ou la suppression de certaines donnees lorsque la loi applicable le permet.",
      "Gerer vos abonnements directement depuis la boutique de votre plateforme."
    ],
  },
  {
    heading: "6. Securite",
    paragraphs: [
      "Nous mettons en place des mesures raisonnables pour proteger les donnees traitees par GoalFit. Aucune methode de transmission ou de stockage n'est toutefois totalement securisee, et nous ne pouvons pas garantir une securite absolue."
    ],
  },
  {
    heading: "7. Enfants",
    paragraphs: [
      "GoalFit n'est pas destine aux enfants en dessous de l'age minimum requis par la loi applicable. Si vous pensez qu'un enfant nous a fourni des donnees personnelles sans autorisation appropriee, contactez-nous."
    ],
  },
  {
    heading: "8. Modifications de cette politique",
    paragraphs: [
      "Nous pouvons mettre a jour cette politique de confidentialite pour refleter l'evolution de GoalFit, de ses fonctionnalites ou de nos obligations legales. La version publiee sur ce site indique la date de derniere mise a jour."
    ],
  },
  {
    heading: "9. Contact",
    paragraphs: [
      "Pour toute question concernant cette politique ou vos donnees personnelles, contactez GoalFit a l'adresse goalfit.support@loven-soft.com."
    ],
  },
];

export default function PrivacyPolicyPage() {
  return (
    <LegalPage
      title="Politique de confidentialite"
      updatedAt="27 avril 2026"
      intro="Cette politique explique comment GoalFit collecte, utilise et partage les informations liees a votre utilisation de l'application mobile GoalFit et de ses services associes."
      sections={sections}
    />
  );
}
